import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input, ElementRef, forwardRef } from '@angular/core';
import { MatSort, MatTableDataSource } from "@angular/material";
import { RuleModel } from '../models/RuleModel';
import { RuleListModel } from '../models/RuleListModel';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import * as ruleActions from '../store/actions';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { Subject } from 'rxjs';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';

@Component({
  selector: 'brd-rule-collection-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => RuleCollectionTileComponent) }],
  templateUrl: './rule-collection-tile.component.html',
  styleUrls: ['./rule-collection-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RuleCollectionTileComponent extends TileComponent implements OnInit, OnDestroy {
  displayedColumns = ['ruleDisplayName', 'ruleDataSet', 'ruleComparisonDate', 'ruleEffectiveDate', 'ruleExpirationDate', 'isEnabled', 'actions'];
  dataSource: MatTableDataSource<RuleListModel>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  selectedRule: RuleListModel;

  editPermission: string = 'RuleModule.BusinessRule:EnableDisable';

  @ViewChild(MatSort)
  sort: MatSort;

  @ViewChild(SearchComponent)
  search: SearchComponent;

  @Input()
  name: string;

  @Input()
  rules: RuleListModel[];

  constructor(
    private store: Store<TileState<RuleListModel, RuleModel>>,
    private changeDetectorRef: ChangeDetectorRef,
    private elementRefContainer: ElementRef,
    private tileContainer: TileContainer,
    private router: Router) {
    super(elementRefContainer);
    tileContainer.tileComponents.push(this);
  }

  toggleEnabled(rule: RuleListModel) {
    rule.isEnabled = !rule.isEnabled;
    if (rule.isEnabled) {
      this.store.dispatch(new ruleActions.EnableRuleAction({ rule: rule }));
    } else {
      this.store.dispatch(new ruleActions.DisableRuleAction({ rule: rule }));
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  ngOnInit() {

    if (this.search) {
      this.search
        .searchControl
        .valueChanges
        .debounceTime(500)
        .takeUntil(this.destroyed$)
        .subscribe(() => {
          this.setupData();
        });
    }

    this.setupData();

  }

  private setupData(): void {
    var ruleListString = sessionStorage.getItem("SelectedRule");
    if (ruleListString) {
      this.selectedRule = JSON.parse(ruleListString);
      var modified = this.rules.find(
        rule => rule.ruleName === this.selectedRule.ruleName
          && rule.collectionDisplayName === this.selectedRule.collectionDisplayName
          && rule.moduleDisplayName === this.selectedRule.moduleDisplayName);
      if (modified != null) {
        modified.isEnabled = this.selectedRule.isEnabled;
      }
    }

    let rulesToDisplay = this.rules.filter(
      rule => rule.ruleName.replace(/\s/g, "").toLowerCase().includes(this.search.searchControl.value.replace(/\s/g, "").toLowerCase()));
    this.dataSource = new MatTableDataSource(rulesToDisplay);
    this.dataSource.sort = this.sort;
    this.changeDetectorRef.markForCheck();
  }

  public selectItem(rule: RuleListModel) {
    this.selectedRule = rule;
    sessionStorage.setItem("SelectedRule", JSON.stringify(this.selectedRule));
    this.router.navigateByUrl("rule-collection/" + rule.ruleDisplayName);
  }

  public clearSelectedItem() {
    this.selectedRule = undefined;
    sessionStorage.setItem("SelectedRule", undefined);
  }

  public getCommonParameter(rule: RuleListModel, parameterName: string, defaultValue : any) {
    var parameter = rule.ruleParameters.find(p => p.key == parameterName);
    return parameter ? parameter.value : defaultValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/components/rule-collection-tile.component.ts